interface ThyroidOrganIconProps {
  className?: string
  size?: number
}

export function ThyroidOrganIcon({
  className,
  size = 32,
}: ThyroidOrganIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
      className={className}
    >
      <path
        fill="currentColor"
        d="M24.22 14.051q.981-.732 1.467-1.457l.004-.005c.769-1.18 1.383-4.069 1.926-6.617.136-.64.265-1.244.383-1.751L27.078 4l-.002.01-.037-.01c-.12.516-.25 1.125-.387 1.77-.472 2.217-1.12 5.254-1.789 6.286-.55.821-1.792 1.726-3.59 2.616-1.585.784-3.257 1.388-4.112 1.677-.354.12-.725.183-1.097.192a3.7 3.7 0 0 1-1.225-.192c-.855-.29-2.527-.893-4.112-1.678-1.798-.89-3.04-1.795-3.59-2.616-.67-1.033-1.317-4.069-1.79-6.287C5.21 5.124 5.08 4.516 4.962 4l-.038.01L4.921 4 4 4.22c.118.508.246 1.112.382 1.752.543 2.548 1.159 5.436 1.927 6.616l.003.006q.509.758 1.556 1.523l.567 11.468c.02.376-.11.733-.365 1.007a1.32 1.32 0 0 1-.967.428l-2.605.018.006.962 2.605-.018a2.25 2.25 0 0 0 1.65-.73 2.33 2.33 0 0 0 .622-1.716l-.533-10.773q.645.387 1.425.774c1.552.769 3.156 1.363 4.228 1.726.476.16.977.241 1.478.241h.103c.48-.007.96-.087 1.417-.241 1.072-.363 2.675-.958 4.227-1.726q.833-.412 1.513-.827l-.536 10.827c-.031.64.19 1.25.622 1.717.434.466 1.02.725 1.65.729L27.58 28l.007-.962-2.605-.018a1.32 1.32 0 0 1-.968-.428 1.37 1.37 0 0 1-.365-1.007z"
      />
      <path
        fill="currentColor"
        d="M19.181 19.733a1.63 1.63 0 0 0-2.267.008q-.136.124-.244.274a4 4 0 0 1-.632.688 3.8 3.8 0 0 1-.58-.619 2.5 2.5 0 0 0-.3-.35 1.63 1.63 0 0 0-2.266-.007l-.047.048a2.41 2.41 0 0 0-.498 2.504l.016.046c.27.756.848 1.354 1.585 1.643.286.118.588.178.892.178v-.001a2.3 2.3 0 0 0 1.011-.233.44.44 0 0 1 .375.004c.574.272 1.24.295 1.83.064l.047-.017a2.75 2.75 0 0 0 1.615-1.61 2.42 2.42 0 0 0-.475-2.557zm-.34 2.26-.005.011c-.185.49-.57.876-1.054 1.056l-.06.021c-.354.14-.753.127-1.095-.036a1.36 1.36 0 0 0-1.184 0 1.38 1.38 0 0 1-1.139.03l-.012-.004a1.8 1.8 0 0 1-1.038-1.072l-.022-.06a1.44 1.44 0 0 1 .291-1.493l.021-.02a.695.695 0 0 1 .964.01l.013.012c.01.009.06.058.18.219.28.374.61.702.981.975.22.161.522.155.736-.014l.034-.027a5 5 0 0 0 .98-1.015 1 1 0 0 1 .119-.133l.012-.011a.696.696 0 0 1 .964-.01l.035.035c.38.408.49 1.006.278 1.525"
      />
    </svg>
  )
}
